var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('labeled-input', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 20,
      expression: "20"
    }],
    attrs: {
      "data-test": "registrationFormEmailInput",
      "label": _vm.getFieldLabel(_vm.$v.merchantEmail, 'registration.email.input.label'),
      "placeholder": _vm.$t('registration.email.input.placeholder'),
      "disabled": _vm.loading,
      "error": _vm.$v.merchantEmail.$error
    },
    on: {
      "focus": _vm.$v.merchantEmail.$reset,
      "blur": _vm.$v.merchantEmail.$touch
    },
    model: {
      value: _vm.merchantEmail,
      callback: function callback($$v) {
        _vm.merchantEmail = $$v;
      },
      expression: "merchantEmail"
    }
  }), _c('labeled-input', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 20,
      expression: "20"
    }],
    attrs: {
      "data-test": "registrationFormPhoneInput",
      "inputmode": "tel",
      "label": _vm.getFieldLabel(_vm.$v.merchantPhone, 'registration.phone.input.label'),
      "placeholder": _vm.$t('registration.phone.input.placeholder'),
      "force-replace": _vm.phoneReplacementRules,
      "maxlength": 15,
      "disabled": _vm.loading,
      "error": _vm.$v.merchantPhone.$error
    },
    on: {
      "focus": _vm.$v.merchantPhone.$reset,
      "blur": _vm.$v.merchantPhone.$touch
    },
    model: {
      value: _vm.merchantPhone,
      callback: function callback($$v) {
        _vm.merchantPhone = $$v;
      },
      expression: "merchantPhone"
    }
  }), _vm.isVisiblePromocode ? _c('labeled-input', {
    attrs: {
      "data-test": "registrationFormPromocodeInput",
      "label": _vm.getFieldLabel(_vm.$v.promoCode, 'registration.promo.code.input.label'),
      "placeholder": _vm.$t('registration.promo.code.input.placeholder'),
      "disabled": _vm.loading,
      "error": _vm.$v.promoCode.$error
    },
    on: {
      "focus": _vm.$v.promoCode.$reset,
      "blur": _vm.$v.promoCode.$touch
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn(_ref) {
        var focus = _ref.focus;
        return [_c('base-button', {
          directives: [{
            name: "m-left",
            rawName: "v-m-left",
            value: 5,
            expression: "5"
          }, {
            name: "color",
            rawName: "v-color",
            value: focus ? 'input-text-focus' : 'input-text',
            expression: "focus ? 'input-text-focus' : 'input-text'"
          }],
          attrs: {
            "data-test": "registrationFormPromocodeHideButton"
          },
          on: {
            "click": function click($event) {
              _vm.isVisiblePromocode = false;
            }
          }
        }, [_c('base-icon', {
          attrs: {
            "name": "basic_circle-x"
          }
        })], 1)];
      }
    }], null, false, 481899657),
    model: {
      value: _vm.promoCode,
      callback: function callback($$v) {
        _vm.promoCode = $$v;
      },
      expression: "promoCode"
    }
  }) : _c('div', {
    class: _vm.$style.placeholder,
    attrs: {
      "data-test": "registrationFormPromocodeShowButton"
    },
    on: {
      "click": _vm.handleShownPromocode
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('registration.promo.code.placeholder.text')) + " ")]), _c('div', {
    class: _vm.$style.submit
  }, [_c('simple-button', {
    attrs: {
      "data-test": "registrationFormSubmitButton",
      "variant": "secondary",
      "disabled": _vm.isInvalidForm
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.registration')) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }